<template>
  <div>
    <div class="lock-sticky left-sticky">
      <b-container fluid>
        <div
          :class="['sidebar-left main-side-setting ', { 'slide-left': show },  {
                'disable-side-btn': disable,
              },]"
          @mouseenter="show = true"
          @mouseleave="show = false"
        >
          <b-row class="row-overwrite text-black">
            <b-col
              ><strong>Select<span v-show="!show">:</span></strong
              ><span v-show="show"> your account:</span></b-col
            >
          </b-row>
          <b-row
            :class="[
              'margin-normal-4 row-setting margin-removal row-overwrite',
              { 'active-row': activeProductType == 'Suite' },
            ]"
            @click="accountType('Suite')"
          >
            <b-col md="4" class="image-change min-width-side-bar my-auto text-center">
              <img
                src="@/assets/images/icons/Account-Suite-Gradient.svg"
                class="image-side-bars smallen-side-image"
                v-show="activeProductType == 'Suite'"
              />
              <img
                src="@/assets/images/icons/Account-Suite-Grey.svg"
                class="image-side-bars smallen-side-image"
                v-show="activeProductType != 'Suite'"
              />
            </b-col>
            <b-col md="8" v-show="show" class="my-auto side-bar-text-size">
              <h5 class="pb-0 mb-0">Full banking suite</h5>
              <p></p>
            </b-col>
          </b-row>
          <b-row
            :class="[
              'margin-normal-4 row-setting margin-removal row-overwrite',
              { 'active-row': activeProductType == 'Card Account' },
              {
                'disable-side-btn': disable,
              },
            ]"
            @click="accountType('Card Account')"
          >
            <b-col
              md="4"
              class="text-center image-change min-width-side-bar my-auto"
            >
              <img
                src="@/assets/images/icons/Account-Credit-Gradient.svg"
                class="image-side-bars smallen-side-image"
                v-show="activeProductType == 'Card Account'"
              />
              <img
                src="@/assets/images/icons/Account-Credit-Grey.svg"
                class="image-side-bars smallen-side-image"
                v-show="activeProductType != 'Card Account'"
              />
            </b-col>
            <b-col md="8" v-show="show" :class="['side-bar-text-size',{'gray-out':disable}]">
              <h5 class="pb-0 mb-0">Credit card</h5>
              <p>account</p>
            </b-col>
          </b-row>
           <b-row
            :class="[
              'margin-normal-4 row-setting margin-removal row-overwrite',
              {
                'active-row':
                  activeProductType ==
                  'Transaction Account (bundled fees)',
              },
              {
                'disable-side-btn': disable,
              },
            ]"
            @click="accountType('Transaction Account (bundled fees)')"
          >
            <b-col md="4" class="image-change min-width-side-bar my-auto text-center">
              <img
                src="@/assets/images/icons/Account-Transaction-Bundled-Gradient.svg"
                class="image-side-bars smallen-side-image"
                v-show="activeProductType == 'Transaction Account (bundled fees)'"
              />
              <img
                src="@/assets/images/icons/Account-Transaction-Bundled-Grey.svg"
                class="image-side-bars smallen-side-image"
                v-show="activeProductType != 'Transaction Account (bundled fees)'"
              />
            </b-col>
            <b-col md="8" v-show="show"  :class="['side-bar-text-size',{'gray-out':disable}]">
             <h5 class="pb-0 mb-0">Transaction</h5>
              <p>with bundled fees</p>
            </b-col>
          </b-row>
         <b-row
            :class="[
              'margin-normal-4 row-setting margin-removal row-overwrite',
              {
                'active-row':
                  activeProductType == 'Transaction Account (pay-as-you-transact fees)',
              },{
              'disable-side-btn':disable
            }
            ]"
            @click="accountType('Transaction Account (pay-as-you-transact fees)')"
          >
            <b-col md="4" class="image-change min-width-side-bar my-auto text-center">
              <img
                src="@/assets/images/icons/Account-Transaction-Gradient.svg"
                class="image-side-bars smallen-side-image"
                v-show="activeProductType == 'Transaction Account (pay-as-you-transact fees)'"
              />
              <img
                src="@/assets/images/icons/Account-Transaction-Grey.svg"
                class="image-side-bars smallen-side-image"
                v-show="activeProductType != 'Transaction Account (pay-as-you-transact fees)'"
              />
            </b-col>
            <b-col md="8" v-show="show"  :class="['side-bar-text-size',{'gray-out':disable}]">
           <h5 class="pb-0 mb-0">Transaction</h5>
              <p>with pay-as-you-transact fees</p>
            </b-col>
          </b-row>
        </div>
        <!-- <b-row class="margin-normal-4"> </b-row> -->
        <div
        
          :class="['left-style-custom','custom-sizing-'+show]"
          @mouseenter="show = true"
          @mouseleave="show = false"
        >
          <b-container
            fluid
            :class="['sidebar-other min-width-side-bar padding-left-right-override padding-2-add-right pl-4 mt-2 smallen-font text-white',healthMemberAct=='yes'?'blue-bg':'grey-bg',{'left-side-side':show}]"
          >
            <b-row>
              <b-col md="3" class="p-3">
                <img
                  src="@/assets/images/icons/running_man.svg"
                  alt=""
                  srcset=""
                  class="image-side-bars smallen-side-image"
                />
              </b-col>
              <b-col md="9" v-show="show" >
                <p class="smallen-font margin-bottom-removal pt-1 text-center">Are you a <strong>Vitality <br> Health </strong>member?</p>
                <div class="inline-radio pb-1">
                  <b-form-radio
                    v-model="healthMemberAct"
                    value="yes"
                    class="radio-blue"
                    >Yes</b-form-radio
                  >
                  <b-form-radio
                    v-model="healthMemberAct"
                    value="no"
                    class="radio-blue"
                    >No</b-form-radio
                  >
                </div>
              </b-col>
            </b-row>
          </b-container>

          <b-container
            fluid
           :class="['sidebar-other padding-2-add-right padding-left-right-override min-width-side-bar mt-1 text-white smallen-font ',driveMemberAct=='yes'?'purple-bg':'grey-bg',{'left-side-side':show}]"
          >
            <b-row>
              <b-col md="3" class="p-3">
                <img
                  src="@/assets/images/icons/car.svg"
                  alt=""
                  class="image-side-bars smallen-side-image "
                />
              </b-col>
              <b-col md="9" v-show="show" class="">
                <p class="smallen-font margin-bottom-removal text-center">Are you a <strong>Vitality <br> Drive </strong>member?</p>
                <div class="inline-radio pb-1">
                  <b-form-radio
                    v-model="driveMemberAct"
                    value="yes"
                    class="radio-purple"
                    >Yes</b-form-radio
                  >
                  <b-form-radio
                    v-model="driveMemberAct"
                    value="no"
                    class="radio-purple"
                    >No</b-form-radio
                  >
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    driveMemberActive: {
      default: "yes",
    },
    healthMemberActive: {
      default: "yes",
    },
    activeProductType: {
      default: "Suite",
    },
    disable: {
      default: false,
    },
  },
  data() {
    return {
      show: false,
      driveMemberAct: this.driveMemberActive,
      healthMemberAct: this.healthMemberActive,
    };
  },
  methods: {
    driveMember(item) {},
    accountType(item) {
      if (this.disable != true) {
        this.$emit("account", item);
      }
    },
    healthMember(item) {
      this.$emit("health", item);
    },
  },
  watch: {
    driveMemberAct() {
      if (this.driveMemberAct == "yes") {
        this.$emit("drive", "yes");
      } else {
        this.$emit("drive", "no");
      }
    },
    healthMemberAct() {
      if (this.healthMemberAct == "yes") {
        this.$emit("health", "yes");
      } else {
        this.$emit("health", "no");
      }
    },
  },
};
</script>

<style lang="scss">
.sidebar-left {
  cursor: pointer;
  position: absolute;
  left: -1em;
  padding: 1em;
  color: black;
  background-color: white;
}
.slide-left {
  width: 20em;
  z-index: 6;
}
.custom-sizing-false{
  width: 5.5em !important;
}
.row-setting {
  height: 4em;
  .image-change {
    filter: opacity(0.5);
  }
}
.min-width-side-bar {
  min-width: 5em;
}
.left-style-custom{
      width: 20em;
}
 @media only screen and (max-height:730px) {
    .lock-sticky {
      position: fixed;
      top:7em;
      z-index: 8;
    }
  }
</style>